// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GHJ8C","colBig":"styles_colBig__13N1v","colSmall":"styles_colSmall__1bPKX"};